import { CSSProperties, MouseEventHandler, TouchEventHandler } from "react";
import styles from "./index.module.scss";
import clsx from "clsx";

type SvgButtonProps = {
  style?: CSSProperties;
  className?: string;
  children: any;
  disabled?: boolean;
  onClick?: MouseEventHandler<HTMLButtonElement>;
  onMouseDown?: MouseEventHandler<HTMLButtonElement>;
  onTouchStart?: TouchEventHandler<HTMLButtonElement>;
  onContextMenu?: MouseEventHandler<HTMLButtonElement>;
}

const SvgButton = (props: SvgButtonProps) => {
  const {
    style,
    className,
    children,
    disabled,
    onClick,
    onMouseDown,
    onTouchStart,
    onContextMenu,
  } = props;

  return (
    <button
      style={style}
      className={clsx(
        styles["svg_button"],
        className,
      )}
      disabled={disabled}
      onClick={onClick}
      onMouseDown={onMouseDown}
      onTouchStart={onTouchStart}
      onContextMenu={onContextMenu}
    >
      {children}
    </button>
  )
}

export default SvgButton;